import RegistrationDashboard from './RegistrationDashboard';

export default RegistrationDashboard;
